module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/covid_measures/2_088445e915446366410a089780e9ee53.png";